import { render, staticRenderFns } from "./MessageHeader.vue?vue&type=template&id=60375510&scoped=true"
import script from "./MessageHeader.vue?vue&type=script&lang=ts"
export * from "./MessageHeader.vue?vue&type=script&lang=ts"
import style0 from "./MessageHeader.vue?vue&type=style&index=0&id=60375510&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60375510",
  null
  
)

export default component.exports